module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Doppio_Senso-CL.064eb6aa.svg";